<template>
<div>
	<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css" integrity="sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N" crossorigin="anonymous">
	<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
		<div class="graph card">
    		<li v-for = "(serial, index) in u.serials" :key = "index"  style="list-style-type: none;">

				<div class="col-12 px-0 mb-0">

					<div class="col-12 px-0 pt-2">
						<div class="col-md-6 row mx-0 px-0" style="background-color: #0091a5;font-size: 1.2em;padding: 0.5em;background-image: linear-gradient(to bottom, #0091a5, #01889a, #027e90, #037585, #036c7b);">	
							<div class="col-auto" v-if="serial.startsWith('KH1')"><img style="width: 30px;" src="../assets/KHA.png"></div>
							<div class="col-auto" v-if="serial.startsWith('CA1')"><img style="width: 30px;" src="../assets/CRA.png"></div>
							<div class="col-auto" v-if="serial.startsWith('KH2')"><img style="width: 40px;" src="../assets/KHApro.png"></div>
							
							<div v-if="u.name === 'default' || u.name === 'khacra'" class="col px-0 align-self-center">
								<input maxlength="12" size="10"  v-model.lazy="u.serials[index]" type="text" value=""></div>
							<div v-else-if="u.devname[index]!=u.serials[index]" class="col px-0 text-white font-weight-bold align-self-center">{{u.s_number[index]}} {{u.devname[index]}}</div>
							<div v-else class="col px-0 text-white font-weight-bold align-self-center">{{u.devname[index]}}</div>
							<div class="col-auto"><button type="reset" class="btn btn-primary" @click="fillData(index)">{{ nav[$route.params.language]['refresh'] }}</button></div>
						</div>
					</div>
					<div v-if="!serial.startsWith('CA1')">

						<div class="col-12 px-0 pt-1 text-center ">
							<div class="col-md-6 row mx-0 p-3" style="background:#f2f2f2">
								<div class="col border-right">
									<div class="col-12 px-0">{{ nav[$route.params.language]['khmeasure'] }}(<span class="col-12 px-0 py-2 text-center" style="font-size:0.8rem" v-if="u.tankKH[index]>0">{{ u.timestamp[index] }}</span>)</div>
										<div class="col-12 px-0"><span class="font-weight-bold" style="font-size:2.5rem" v-if="u.tankKH[index]>0">{{ u.tankKH[index] }}</span>dKH</div>
										<div class="col-12 px-0 text-center"><router-link :to="{ name: 'kh-graph', params: { language: $route.params.language, sidx: index }}"><button class="btn btn-primary" style="min-width: 110px;">{{ nav[$route.params.language]['showkhgraph'] }}</button></router-link></div>	
								</div>
								<div class="col">
									<div v-if="serial.startsWith('KH2')">
										<div class="col-12 px-0" v-if="u.phSignal[index]>=100 && u.phSignal[index]<1000">PH</div>
										<div class="col-12 px-0" v-else>{{ nav[$route.params.language]['probelife'] }}</div>  <!--PH life time-->
										<div class="col-12 px-0 py-1">
											<span class="font-weight-bold" style="font-size:2.5rem;line-height: 3rem;" v-if="u.phSignal[index]>=0 && u.phSignal[index]<100"  >{{ u.phSignal[index] }}%</span>
											<span class="font-weight-bold" style="font-size:2.5rem;line-height: 3rem;" v-if="u.phSignal[index]>=100 && u.phSignal[index]<1000"  >{{ u.phSignal[index]/100 }}</span>
											<span class="font-weight-bold text-danger" style="font-size:2.5rem;line-height: 3rem;" v-if="u.phSignal[index]>=1000"  >fail</span>
										</div>
									</div>
									<div v-if="serial.startsWith('KH1')">
										<!--<div class="col-12 px-0">{{ nav[$route.params.language]['probelife'] }}</div>-->
										<div class="col-12 px-0 py-1">
											<span class="font-weight-bold" style="font-size:2.5rem;line-height: 3rem;" v-if="u.phSignal[index]>=0 && u.phSignal[index]<100"  >{{ u.phSignal[index] }}%</span>
											<span class="font-weight-bold" style="font-size:2.5rem;line-height: 3rem;" v-if="u.phSignal[index]>=100 && u.phSignal[index]<1000"  >100%</span>
											<span class="font-weight-bold text-danger" style="font-size:2.5rem;line-height: 3rem;" v-if="u.phSignal[index]>=1000"  >fail</span>
										
										</div>
									</div>
								<div class="col-12 px-0 text-center">
									<span v-if="u.phSignal[index]<0"></span>
									<span v-else-if="u.phSignal[index]>=100 && u.phSignal[index]<1000">{{ nav[$route.params.language]['probemessage1'] }}</span>
									<span v-else class="text-danger font-weight-bold">{{ nav[$route.params.language]['changeprobe'] }}</span>
								</div>
								<div class="col-12 px-0 text-center">
									<span v-if="u.er_c[index]>=5" class="text-danger font-weight-bold">#{{u.er_pump[index]}} {{ nav[$route.params.language]['changepump'] }}</span>
								</div>
							</div>
							</div>
						</div>

						<div class="col-12 px-0 pt-1 text-center ">
							<div class="col-md-6 row mx-0 p-3" style="background:#f2f2f2">
								<div class="col border-right">
									<div class="col-12 px-0">{{ nav[$route.params.language]['targetkh'] }}</div>
									<div class="col-12 px-0"><span class="font-weight-bold" style="font-size:2.5rem">{{ u.targetKH[index] }}</span>dKH</div>
									<div class="col-12 px-0 text-center"><router-link :to="{ name: 'kh-settings', params: { language: $route.params.language , sidx: index}}"><button class="btn btn-primary" style="min-width: 110px;">{{ nav[$route.params.language]['targetset'] }}</button></router-link></div>								
								</div>
								<div class="col" v-if="serial.startsWith('KH1')">
									<div class="col-12 px-0" v-if="u.trueKH[index]==0">{{ nav[$route.params.language]['calibration'] }}</div>
									<div class="col-12 px-0 text-danger font-weight-bold" v-if="u.trueKH[index]>0">{{ nav[$route.params.language]['nextcalib'] }}</div>
									<div class="col-12 px-0 py-1" v-if="u.trueKH[index]==0" ><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADtElEQVR4nO2aW0tUURiGH6hs7izQKTLTLrOLzhAElR3+RmiYQQXdFdLBICr7CUEHO0Op/YfUIoisuw6OZmGHm8pKMygnFrwbFtM4e609e89o+cJmmNnvOnz7O65vD8zBGVldsx7ZOUHKhHnAOuAgcKOARm6Is1ZjZgxqgFPAR2vT9san+57VmA5gJWXESqAb+G1tLAN0As0FBGkWJ2PdM3N0AfWlFGABcBj4pk1MAneALRGcfQNwARgXZ0LaXUjCWAI80qJTwBUgHUPUMvNe1ZyG+8Bh3shYDQxroUFgWwLhtxEYEt98NpCAEJ+1QC9QlWAeqQb6NeZTnMIstTTRFcF+oyTEFNBjacaYXlFYaPlEb0QnjJrZU5ZmHgIVFIFjlk/4mFNcJUq1FabbiskTE4okWz3GLQZaCwiyD1jkMV+j9jAeNc8ENnrZkW/Mrh346pDZx4CTHuZy1fJRb238lkaMesOwAnhmbbqvgCB91m8DQK3D/GngB/ALqPMR5JwWuuQoxFvxh2UKYT6yA3it398Ayx3W6RT/jKsQ860CcL2DOT21tFDl4ezVyuDm3hMHM9sk7gfXqnm9Brx04LZbmogS1YwwI5rjuAN/UFxzXAjFIZEvOkSnMXG3Ex07NccXoDKEe1lcc54JxW2R94Tw9lsFXrG4r7laQnhN4t2ihDA2fx4Y1XVWR4BZh46c02BWuSNRZGO6bLzLc/9F0utmExBkNM/95yV4gP+GaSXl7B3ldPZbenom1BVCa4zht9cx/O4Vz+6bhSbEsDprkZUQc+srH+z2SIid4h7wKVFeOXBPiPs6YomS9ixRhsVd41s0bnTwgwFx+6cp+V2KxscO/rNZ3Pc+rdazGmT6VmGoVSme1dPd5SDITksTI2q7huG6+KfxQL0OVj8cG2W1KsWzlnamEyRw7EATNY6dnEkdrMz5xwvdWswcM11QIZ/5krPxXEECxz7mEY6va5xpzXqjXgf+Kc8yvTInjOYK0uIQnfKV+d+jaCNAmybJOJ7d86GYMiJtRaojFIEKNccCuzdNs1IJkrKiWl8cVUHaaiz3RBAmiiAp4F4M1vAXGtRQLpQv4hIkbWnCrLmKmNFgaSbjUZb4CLLD8olMEkLYTyvwGRPNrinGFyvIEs01FVHrsbx6+6n4npvRo7x6G9ert6I6774wrcu7yrbBZoccXoY2qfSxX4b+0lx1lBHLgKNW2zRfJs/3Pegalv31dC7mqbwO+8PATZ15ZtwfBsJQkgZBKTAnyH+JP9RewEUWCMmeAAAAAElFTkSuQmCC"></div>
									<div class="col-12 px-0 font-weight-bold" style="font-size:2.5rem" v-if="u.trueKH[index]>0">{{ u.trueKH[index].toFixed(2) }}</div>
									<div class="col-12 px-0 text-center"><router-link :to="{ name: 'kh-calibration', params: { language: $route.params.language, sidx: index }}"><button class="btn btn-primary" style="min-width: 110px;">{{ nav[$route.params.language]['calibrate'] }}</button></router-link></div>
								</div>
								<div class="col" v-if="serial.startsWith('KH2')">
									<div class="col-12 px-0" v-if="u.trueKH[index]==0">{{ nav[$route.params.language]['calibration'] }}</div>
									<div class="col-12 px-0 text-danger font-weight-bold" v-if="u.trueKH[index]>0">{{ nav[$route.params.language]['nextcalib'] }}</div>
									<div class="col-12 px-0 py-1" v-if="u.trueKH[index]==0" ><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADtElEQVR4nO2aW0tUURiGH6hs7izQKTLTLrOLzhAElR3+RmiYQQXdFdLBICr7CUEHO0Op/YfUIoisuw6OZmGHm8pKMygnFrwbFtM4e609e89o+cJmmNnvOnz7O65vD8zBGVldsx7ZOUHKhHnAOuAgcKOARm6Is1ZjZgxqgFPAR2vT9san+57VmA5gJWXESqAb+G1tLAN0As0FBGkWJ2PdM3N0AfWlFGABcBj4pk1MAneALRGcfQNwARgXZ0LaXUjCWAI80qJTwBUgHUPUMvNe1ZyG+8Bh3shYDQxroUFgWwLhtxEYEt98NpCAEJ+1QC9QlWAeqQb6NeZTnMIstTTRFcF+oyTEFNBjacaYXlFYaPlEb0QnjJrZU5ZmHgIVFIFjlk/4mFNcJUq1FabbiskTE4okWz3GLQZaCwiyD1jkMV+j9jAeNc8ENnrZkW/Mrh346pDZx4CTHuZy1fJRb238lkaMesOwAnhmbbqvgCB91m8DQK3D/GngB/ALqPMR5JwWuuQoxFvxh2UKYT6yA3it398Ayx3W6RT/jKsQ860CcL2DOT21tFDl4ezVyuDm3hMHM9sk7gfXqnm9Brx04LZbmogS1YwwI5rjuAN/UFxzXAjFIZEvOkSnMXG3Ex07NccXoDKEe1lcc54JxW2R94Tw9lsFXrG4r7laQnhN4t2ihDA2fx4Y1XVWR4BZh46c02BWuSNRZGO6bLzLc/9F0utmExBkNM/95yV4gP+GaSXl7B3ldPZbenom1BVCa4zht9cx/O4Vz+6bhSbEsDprkZUQc+srH+z2SIid4h7wKVFeOXBPiPs6YomS9ixRhsVd41s0bnTwgwFx+6cp+V2KxscO/rNZ3Pc+rdazGmT6VmGoVSme1dPd5SDITksTI2q7huG6+KfxQL0OVj8cG2W1KsWzlnamEyRw7EATNY6dnEkdrMz5xwvdWswcM11QIZ/5krPxXEECxz7mEY6va5xpzXqjXgf+Kc8yvTInjOYK0uIQnfKV+d+jaCNAmybJOJ7d86GYMiJtRaojFIEKNccCuzdNs1IJkrKiWl8cVUHaaiz3RBAmiiAp4F4M1vAXGtRQLpQv4hIkbWnCrLmKmNFgaSbjUZb4CLLD8olMEkLYTyvwGRPNrinGFyvIEs01FVHrsbx6+6n4npvRo7x6G9ert6I6774wrcu7yrbBZoccXoY2qfSxX4b+0lx1lBHLgKNW2zRfJs/3Pegalv31dC7mqbwO+8PATZ15ZtwfBsJQkgZBKTAnyH+JP9RewEUWCMmeAAAAAElFTkSuQmCC"></div>
									<div class="col-12 px-0 font-weight-bold py-1" style="font-size:2.0rem" v-if="u.trueKH[index]==1.23">{{ nav[$route.params.language]['calliquid']  }}</div>
									<div class="col-12 px-0 font-weight-bold" style="font-size:2.5rem" v-else-if="u.trueKH[index]>0">{{ u.trueKH[index].toFixed(2) }}</div>
									<div class="col-12 px-0 text-center"><router-link :to="{ name: 'kh-calibration', params: { language: $route.params.language, sidx: index }}"><button class="btn btn-primary" style="min-width: 110px;">{{ nav[$route.params.language]['calibrate'] }}</button></router-link></div>
								</div>
							</div>
						</div>

						<div class="col-12 px-0 pt-1 text-center">
							<div class="col-md-6 row mx-0 p-3" style="background:#f2f2f2">
								<div class="col border-right">
									<div class="col-12 px-0 text-center text-danger font-weight-bold" v-if="u.KHRemain[index]<u.mlspec[index]" style="font-size:1rem">{{ nav[$route.params.language]['refillsolution'] }}</div>
									<div class="col-12 px-0" v-else>{{ nav[$route.params.language]['dosingsolution'] }}</div>
									<div class="col-12 px-0 py-1" v-if="u.KHRemain[index]<10000"><span class="font-weight-bold" style="font-size:2.5rem;line-height: 3rem;">{{u.KHRemain[index]}}</span>ml</div>
									<div class="col-12 px-0 py-1" v-else><span class="font-weight-bold" style="font-size:2.0rem;line-height: 3rem;">{{u.KHRemain[index]}}</span>ml</div>
									
									<div class="col-12 px-0 text-center"><router-link :to="{ name: 'kh-dosing', params: { language: $route.params.language, sidx: index }}"><button class="btn btn-primary" style="min-width: 110px;">{{ nav[$route.params.language]['setup'] }}</button></router-link></div>	
								</div>
								<div class="col" v-if="serial.startsWith('KH2')">
									<div class="col-12 px-0 text-center text-danger font-weight-bold" v-if="u.CalRemain[index]<u.mlspec[index]" style="font-size:1rem">{{ nav[$route.params.language]['refillcalsolution'] }}</div>
									<div class="col-12 px-0" v-else>{{ nav[$route.params.language]['calsolution'] }}</div>
									<div class="col-12 px-0 py-1"><span class="font-weight-bold" style="font-size:2.5rem;line-height: 3rem;">{{u.CalRemain[index]}}</span>ml</div>
									
									<div class="col-12 px-0 text-center"><router-link :to="{ name: 'kh-calsolution', params: { language: $route.params.language, sidx: index }}"><button class="btn btn-primary" style="min-width: 110px;">{{ nav[$route.params.language]['setup'] }}</button></router-link></div>	
								</div>
								<div class="col" v-else>
									</div>
							</div>			
						</div>
					</div>
					
					<div v-if="serial.startsWith('CA1')">
						<div class="col-12 px-0 pt-1 text-center">
							<div class="col-md-6 row mx-0 p-3" style="background:#f2f2f2">
								<div class="col border-right">
									<div class="col-12 px-0">{{ nav[$route.params.language]['kherror'] }}</div>
									<div class="col-12 px-0 py-0 text-center" style="font-size:0.8rem">({{ u.timestamp[index] }})</div>
									<div v-if="u.tankKH[index]<0" class="col-12 px-0"><span class="font-weight-bold" style="font-size:2.5rem" >{{ u.tankKH[index]*-1 }}</span>dKH</div>
									<div v-else class="col-12 px-0"><span class="font-weight-bold" style="font-size:2.0rem" >{{ u.tankKH[index]*-1 }}</span>dKH</div>
									<div class="col-12 px-0 text-center"><router-link :to="{ name: 'CaRx-graph', params: { language: $route.params.language, sidx: index }}">
										<button class="btn btn-primary" style="min-width: 110px;">{{ nav[$route.params.language]['showkhgraph'] }}</button></router-link></div>	
								</div>
								<div class="col">
									<div class="col-12 px-0">{{ nav[$route.params.language]['CAsetting'] }}</div>
									    <div class="col-12 px-0 py-1" style="line-height: 4rem;" ><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADMklEQVR4nNWa34tNURTHPzKiSaZomDQNpkGuB6VGKcqv8uAVr4R/YNQ8STxoROGBTFLi2ZOMpLxo/KhJiDEz5UG5fuTBVWqGXOZqZ506ndnnnP3r3DnzrfVwb/uutb577/Vj730hLM4Cf4FGQv4A/cwhfNSQiOQFcwRLgOkMIj+B+cwBbM0gEcn62XSwCzgOtOeMO2pA5ECOjnaxpWwGxWrgvTjxFdiXMfaCAZHTGb/fBXyScVWgJxSJHlEYd0TFwEVgYWLsMuCZAZGHwOLEbxcA5zTZrhqCjI5EXF4BFWAbcAf4bUAikkngFrBR7IxkjK36kOnMIRFJ3cJ5nagVmDIYVxWfrHHY08Ei5JALkVZgogTON0TeaeLKGJst931RUge24IlTJSByggBoMUypRcmTkC3N2gDZyUWmgG4CYqejI6PAXZG3jqm5EpLIfQvjKjlcBlaltDpXLFf3RigSHXIgMjH6DdhhuMI1Q50/pBRYo01a8WPST41YrIQJiXhzaLoyj4DzwBFJw+rMk3k8NWlJ0kRtJ1tc9bD3ARjQKdWdsU1lOiUm8rDGw2ZDfJ4BH4UqO7lizNP2DPgoU+nVFUNlIjLkQeRemYiMlmlr1T0VqmJni25Pm3Wd0n65PPvlqFRVbFsMevRgz4G+vG53A3AQOAMMW8yOqtim2GOxCx7Izct+YJ1rN7zcwmBNKnYedgPfLXQuIhBsUmRdKrYqdrqYGCzgSFADrpkchbc7GhiTSVAyHtj5hkYUmUxUCpjFXsKhN9Z9p0LdJr5swmyGklRcKoFzDV8ie3PeOgqZuVi2zLv5jyNVr1LyeTa2AP9PpSpRvLYgk6q3r0lboEVDYlzGjMnKeBHpMjwxurY0CvOAm8B1eVaIkxiXz6bIXOm8Z4WnMkalv9uWpKK0Phl7M3ElgcmW1ZFRFw0nNdtiqZCz2VpqEr7Evo9IBAv2NDITOcXM5OktaVCd99/ESHSEDPYkOuXNpDXAY6gu2NU11Ioigr3I5+mmB7sL2gyLaNODPfRfOJIGNyWSiYrBlQ42CyEyYHDhlxXslIWIi8Eo2EPrLQxFGWzMFpGihGbhcYEkhv8BZG3QcBC3xlMAAAAASUVORK5CYII="></div>
									<div class="col-12 px-0 text-center"><router-link :to="{ name: 'CaRx-settings', params: { language: $route.params.language , sidx: index}}">
										<button class="btn btn-primary" style="min-width: 110px;">{{ nav[$route.params.language]['targetset'] }}</button></router-link></div>								
								</div>
							</div>
						</div>
					</div>
	
					<div v-if="u.name === 'default' || u.name === 'khacra'" class="col-12 px-0 pt-1 text-center ">
						<fieldset class="col-md-6" style="background-color:#81cb07;font-size: 1em;padding: 0.3em;border-radius: 0.2em;">
							<label><strong>{{ nav[$route.params.language]['aiadvisor'] }}</strong> </label>
							<span style="float:right;"><button type="reset" style="height:25pt;padding:2pt;" class="btn btn-primary" @click="addMsg(index)">{{ nav[$route.params.language]['upload'] }}</button></span>
							<textarea v-model="u.message_dev[index]"  class="form-control" rows="1" placeholder="add comments to show to device owner"></textarea>                
							
						</fieldset>
					</div>
    			
    				<div v-else class="col-12 px-0 pt-1  ">
						<fieldset class="col-md-6" v-if="u.message_dev[index] !==''" style="background-color:#81cb07;font-size: 1em;padding: 0.3em;border-radius: 0.2em;">
							<label><strong>{{ nav[$route.params.language]['aiadvisor'] }}</strong></label> 
							<span style="float:right;"><button type="reset" style="height:25pt;padding:2pt;" class="btn btn-primary" @click="clearMsg(index)">{{ nav[$route.params.language]['igotit'] }}</button></span>
							<p class="form-control">{{ u.message_dev[index] }}</p>
						</fieldset>
                    </div>
				
				</div>
				
			</li>
			<div><span style="float:right;">v1.3</span></div>
		</div>
	</div>	
		 	
		
</template>

<script>
//import Log from 'loglevel';
import has from 'lodash/has';
import map from 'lodash/map';
//import LineGraph from './LineGraph.vue'
let PURL = process.env.SERVER;

     
function getFieldValues(res, fieldName) {
  let fValues = [];
  //console.log('getFieldValue() field: ', fieldName);
  if (fieldName.match(/^field/)) {
    fValues = map(res, function (entry) {
      // console.log("entry: ", entry[1], entry.length);
      if (entry.length >= 2) {
        let obj = entry[1];
        return obj[fieldName];
      } else {
        return "undefined";
      }
    });
  }
  //console.log(fieldName, fValues);
  return fValues;
}

function writeMsg(Vue,sidx,msg) {
	let user = JSON.parse(localStorage.getItem("user")) || {};  
	let url = PURL + '/api/v1/KH/write-message';
	let body = {
		"user": Vue.u.name || user.name,
		"serial": ''
	};

	//console.log('server: ', PURL, process.env, user);
	if (body.user === "default") {
		body.serial = Vue.u.serials[sidx];
	} else {
	    body.serial = user.data.devices[sidx];
	}
	//has(user, 'data.devices[0]') ? body.serial = user.data.devices[0] : '';
	body['field21'] = ""; body['field21'] = msg;
	//console.log('writeMsg() url: ', url, body, Vue.$store.user);
	// asynch call
	let p1 = Vue.$http.post(url, body);
	Promise.all([p1]).then(([r1]) => {
		//console.log("writeMsg() value: ", r1);
	console.log("Write message_dev done");	
	}, reason => {
		let rea=JSON.stringify(reason) ; 
		console.log('server error: ', reason);
		Vue.$set(Vue.u.message_dev, sidx, 'error: server error');
		//   Vue.u.message_dev = 'error: unknown error: ' + JSON.stringify(reason);
		if (rea.match(/no serial/gi)) {
			Vue.$set(Vue.u.message_dev, sidx, 'invalid serial numer');
		}
		console.log("reason: ", reason);
	});
    
}


////////// get Vue.u parameter from localstorage or ui-server ////////////
function getData(Vue, serials, allsidx) {
	let user = JSON.parse(localStorage.getItem("user")) || {};  
	
/*
	if (user && user.sleep && //if localstorage user && user.sleep exist
		user.data.devices.length == user.serials.length &&  //// user.serials is saved to localstorage after get data from server, if add device in Profile.vue then length is different
		Vue.u.name!='default') { // super user always change serial, need to reload parameters from ui-server
	    Vue.u = user;  // restore Vue.u parameters from localstorage user                                
		console.log("My-KH -- get parameters from localstorage");
	} else {  			// request Vue.u parameters from ui-server
*/
		console.log("My-KH -- get parameters from server");
		for (let ssidx = 0; ssidx < allsidx.length; ssidx++) {    // allsidx=[0, 1, 2] content is index of serials. sidx=allsidx(ssids) , serial=serials[sidx]
			let sidx = allsidx[ssidx];
			let serial = serials[sidx]; 
			let snumber = serial.split('-')[2].substring(2);  // 00002.substring(2) = 002
			let product = serial.split('-')[0];
			let body = {
				"user": Vue.u.name || user.name,
				"password": ''
			};
						
			let urls = PURL + '/api/v1/KH/' + serial + '/' + 'all_field';
			// asynch call
			let ps = Vue.$http.post(urls, body);
			Promise.all([ps]).then(([rs]) => {
				if ((rs.status === 200 || rs.status === 204)) {
					
					Vue.$set(Vue.u.targetKH, sidx, rs.data['field8']);	// product = CA1
					if (product != "CA1") {
						Vue.$set(Vue.u.targetKH, sidx, rs.data['field8'] / 1000); //Vue.u.targetKH[sidx] = r1.data / 1000; cannot use regular assignment in array object.otherwise result won't update
						Vue.$set(Vue.u.targetKH, sidx, Vue.u.targetKH[sidx].toFixed(1));}
						
					Vue.$set(Vue.u.timeHr, sidx, rs.data['field13']/10000);
					Vue.$set(Vue.u.KHRemain, sidx, Math.round(rs.data['field14']));
					Vue.$set(Vue.u.CalRemain, sidx, rs.data['field12']);    // for CaRx-settingd text
					if (product!== 'CA1') {Vue.$set(Vue.u.CalRemain, sidx, Math.round(rs.data['field12'])); }    // for KH-dosing settings
					Vue.$set(Vue.u.trueKH, sidx, rs.data['field10'] / 1000);   // for KH-calibration too.
					Vue.$set(Vue.u.message_dev, sidx, rs.data['field21']);
					Vue.$set(Vue.u.devname, sidx, rs.data['serial']);
					Vue.$set(Vue.u.s_number, sidx, snumber);

					if (Vue.u.KHRemain[sidx] < 0) {Vue.$set(Vue.u.KHRemain, sidx, 0);}
					if (Vue.u.CalRemain[sidx] < 0) {Vue.$set(Vue.u.CalRemain, sidx, 0);}
					Vue.$set(Vue.u.timeHr, sidx, parseFloat(Vue.u.timeHr[sidx]).toFixed(0));
					
					///////// for latest data ///////
					if (rs.data.hasOwnProperty('latest') && rs.data['latest']['time']!="") {
					//if (rs.data['latest']['kh'] !="") {   // if latest is saved in dev config
						let tt=new Date(rs.data['latest']['time']);
						Vue.$set(Vue.u.timestamp,sidx, tt.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false}) + ', ' 
							+ tt.toLocaleDateString([], {month:'2-digit', day:'2-digit'}));
						Vue.$set(Vue.u.tankKH, sidx, (rs.data['latest']['kh']/1000).toFixed(2));
						Vue.$set(Vue.u.phSignal, sidx, rs.data['latest']['ph']);
					}
					//////// for pump fail display /////////
					if (rs.data.hasOwnProperty('er_count') && rs.data['er_count']>200) {
                        let erc = rs.data['er_count']%10; // 235%10=5, error count
						let er_p = Math.floor(rs.data['er_count']%100/10); // 234%100=34, 34/10=3.4 tofixed=3  error pump
						Vue.$set(Vue.u.er_c, sidx, erc);  
						Vue.$set(Vue.u.er_pump, sidx, er_p); 
					}
						
					console.log("Configs: ", serial);
					//console.log('getData() ssidx=', ssidx, "targetKH=" + Vue.u.targetKH[ssidx]);
					
					//////// for KH_settings ///////
					Vue.$set(Vue.u.KHspec, sidx, rs.data['field15']/1000);
					Vue.$set(Vue.u.sleep, sidx, rs.data['field13']);
					//////// for KH_dosing.vue ///////////
					Vue.$set(Vue.u.KHdosing, sidx, rs.data['field5']);   // for CaRx-settings too
					Vue.$set(Vue.u.maxKHdosingPerHr, sidx, rs.data['field6']);
					Vue.$set(Vue.u.PairDev, sidx, rs.data['field11']);   // for CaRx-settings too
					Vue.$set(Vue.u.mlspec, sidx, Math.round(rs.data['field16'])); 
					//////// saved to localstorage /////
					localStorage.setItem('user', JSON.stringify(Vue.u)); 
	         		user = JSON.parse(localStorage.getItem("user"));
	
				}
			}, reason => {
				let rea=JSON.stringify(reason) ; 
				console.log('server error: ', reason.body);
				if (rea.match(/device not found/gi)) {
					Vue.$set(Vue.u.message_dev, sidx, "device not found " + serial);}
				Vue.setMsg(Vue.u.message_dev[sidx], 2, sidx);
			});
		}  // config for all serial 
//	}  // if  user user.sleep 
        
		/////////// always get latest data from ui-server /////////////
	/*	
		for (let ssidx = 0; ssidx < allsidx.length; ssidx++) {    // allsidx=[0, 1, 2] content is index of serials. sidx=allsidx(ssids) , serial=serials[sidx]
				let sidx = allsidx[ssidx];
			if (Vue.u.tankKH[sidx] =="") {   // if latest is not saved in dev config
				let serial = serials[sidx];
				let body = {
					"user": Vue.u.name || user.name,
					"password": ''
				};
			
				let date = new Date().toJSON().slice(0,10);
				let url = PURL + '/api/v1/query/device/' + serial + '/latest';
			
				let p1 = Vue.$http.get(url);
				var maxdata = 0;
				var mindata = 100;
				console.log("latest data from server: ", serial);
				Promise.all([p1]).then(([r1]) => {
					if ((r1.status === 200 || r1.status === 204)) {
					//console.log("latest serial, r1: ", serial, r1.body.results.length, r1);
						if (has(r1, 'body.results.length') && r1.body.results.length !== 0) {
							let body = r1.body;
							let res = r1.body.results;
							let fields = Object.keys(res[0][1]);
							//let times = Array(body['sample_size']);
							let times = [];
							times = map(res, function (entry) { return new Date(entry[0]); });
							
							let len = times.length;
							//console.log("latest data: ", r1);
							//console.log ('time: ', times, times[0]);
							Vue.$set(Vue.u.timestamp,sidx, times[0].toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false}) + ', ' 
										+ times[0].toLocaleDateString([], {month:'2-digit', day:'2-digit'}));
							
							let field22 = fields[0]; // to get last data of field 22
							let f22data = getFieldValues(res, field22);
							let f22res = Number(f22data / 1000).toFixed(2);
							Vue.$set(Vue.u.tankKH, sidx, f22res);
							
							let field24 = fields[2]; // to get last data of field 24
							let f24data = getFieldValues(res, field24);
							let f24res=Math.max(Math.round((f24data[f24data.length-1])/50),0);  // /100 --> /50 to consist KHA lcd display
							Vue.$set(Vue.u.phSignal, sidx, f24res);
						} else {      //has result & result length
							Vue.$set(Vue.u.timestamp,sidx, 0);
							Vue.$set(Vue.u.tankKH, sidx, 0);
							Vue.$set(Vue.u.phSignal, sidx, -1);
						}  
				//////// save parameters to local /////////
					//if (ssidx===allsidx.length-1) {
					//	localStorage.setItem('user', JSON.stringify(Vue.u)); 
					//	user = JSON.parse(localStorage.getItem("user"));  
											
						//console.log("after getData() localstorage user: ", user);
						//console.log('after getData() Vue', Vue);
						//console.log('after getData() $store.getters.user: ', Vue.$store.getters.user);
					//} // local store combine user (Login.vue), latest data, and config (My-KH) save in local
				
				}
				}, reason => {  // promise.all
					let rea=JSON.stringify(reason) ; 
					console.log('server error: ', reason);
					if (rea.match(/device not found/gi)) {
						Vue.$set(Vue.u.message_dev, sidx, "device not found " + serial);}
					Vue.setMsg(Vue.u.message_dev[sidx], 2, sidx);
				});
		    } // if
		
		} // for loop latest data for all serial sidx
	*/		
}


const Nav = {
	'en': {
		'controller': '', 
		'refresh':'Refresh',
		'parameter':'Parameter',
		'value':'Value',
		'remarks': 'Remarks',
		'targetkh': 'KH Target',
		'targetset':'Setup',
		'measureinterval':'Measurement Interval (hour)',
		'settimer':'Set Timer',
		'kherror':'KH Error',
		'khmeasure':'KH  ',
		'showgraph':'Graph',
		'showkhgraph':'Graph',
		'calibration':'Calibration now',
		'nextcalib':'wait calibration',
		'calibrate':'Calibrate',
		'calliquid':'Calibration Solution',
		'probelife':'PH Probe Health',
		'changeprobe':'Suggested change PH probe',
		'changepump':' Pump Fail',
		'probemessage1':'PH Healthy',
		'dosingsolution':'KH Dosing(ml)',
		'calsolution':'Calibration(ml)',
		'refillsolution':'Refill KH',
		'setup':'Setup',
		'CAsetting':'CRA Settings',
		'aiadvisor':'AquaWiz Advisor: ',
		'entermessage':'add comments to show to device owner',
		'upload':'Set',
        'igotit':'Dismiss',
		'refillcalsolution':'Refill Cal',
	},
	'ms': {
		'controller': '', 
		'refresh':'Refresh',
		'parameter':'Parameter',
		'value':'Value',
		'remarks': 'Remarks',
		'targetkh': 'KH Target',
		'targetset':'Setup',
		'measureinterval':'Measurement Interval (hour)',
		'settimer':'Set Timer',
		'kherror':'KH Error',
		'khmeasure':'KH  ',
		'showgraph':'Graph',
		'showkhgraph':'Graph',
		'calibration':'Calibration now',
		'nextcalib':'wait calibration',
		'calibrate':'Calibrate',
		'calliquid':'Calibration Solution',
		'probelife':'PH Probe Health',
		'changeprobe':'Suggested change PH probe',
		'changepump':' Pump Fail',
		'probemessage1':'PH Healthy',
		'dosingsolution':'KH Dosing(ml)',
		'calsolution':'Calibration(ml)',
		'refillsolution':'Refill KH',
		'setup':'Setup',
		'CAsetting':'CRA Settings',
		'aiadvisor':'AquaWiz Advisor: ',
		'entermessage':'add comments to show to device owner',
		'upload':'Set',
        'igotit':'Dismiss',
		'refillcalsolution':'Refill Cal',
	},
	'vi': {
		'controller': '', 
		'refresh':'Làm Mới',
		'parameter':'Tham số',
		'value':'Giá trị',
		'remarks': 'Bình luận',
		'targetkh': 'Mục tiêu KH',
		'targetset':'Cài Đặt',
		'measureinterval':'Khoảng thời gian đo (giờ)',
		'settimer':'Đặt hẹn giờ',
		'kherror':'KH Lỗi',
		'khmeasure':'KH  ',
		'showgraph':'Biểu Đồ',
		'showkhgraph':'Biểu Đồ',
		'calibration':'Hiệu chuẩn ngay bây giờ',
		'nextcalib':'Chờ hiệu chuẩn',
		'calibrate':'Hiệu Chuẩn',
		'calliquid':'Giải pháp hiệu chuẩn',
		'probelife':'Tình Trạng Đầu Dò PH',
		'changeprobe':'Đề nghị thay đổi đầu dò PH',
		'changepump':' Pump Fail',
		'probemessage1':'Tình Trạng Bình Thường',
		'dosingsolution':'KH định lượng(ml)',
		'calsolution':'Định lượng(ml)',
		'refillsolution':'Nạp Thêm KH',
		'setup':'Cài Đặt',
		'CAsetting':'Cài Đặt CRA',
		'aiadvisor':'AquaWiz Advisor: ',
		'entermessage':'thêm nhận xét để hiển thị cho chủ sở hữu thiết bị',
		'upload':'Set',
        'igotit':'Dismiss',
		'refillcalsolution':'Nạp Thêm CA',
		},
	'tw': {
		'controller': '', 
		'refresh': '更新',
		'parameter':'參數名稱',
		'value':'數值',
		'remarks': '備註',
		'targetkh': 'KH目標值',
		'targetset':'設定',
		'measureinterval':'測量間隔 (小時)',
		'settimer':'設定量測間隔',
		'kherror':'KH誤差值',
		'khmeasure':'KH  ',
		'showgraph':'圖表',
		'showkhgraph':'圖表',
		'calibration':'立即校正KH',
		'nextcalib':'待校正',
		'calibrate':'校正',
		'calliquid':'校正液',
		'probelife':'PH計狀態',
		'changeprobe':'建議更換',
		'changepump':' 馬達故障',
		'probemessage1':'PH計健康',
		'dosingsolution':'KH提升液',
		'calsolution':'KH校正液',
		'refillsolution':'補充提升液',
		'setup':'設定',
		'CAsetting':'CRA設定',
		'aiadvisor':'AquaWiz提示: ',
		'entermessage':'輸入給使用者的建議',
		'upload':'上傳',
        'igotit':'我知道了',
		'refillcalsolution':'補充校正液',
	},
	'cn': {
		'controller': '',
		'refresh': '更新',
		'parameter':'参数名',
		'value':'数值',
		'remarks': '备注',
		'targetkh': 'KH目标值',
		'targetset':'设定',
		'measureinterval':'测量间隔 (小时)',
		'settimer':'设定测量间隔',
		'kherror':'KH偏差值',
		'khmeasure':'KH  ',
		'showgraph':'图表',
		'showkhgraph':'图表',
		'calibration':'立即校准KH',
		'nextcalib':'待校准',
		'calibrate':'校准',
		'calliquid':'校准液',
		'probelife':'PH计状态',
		'changeprobe':'建议更换',
		'changepump':' 马达故障',
		'probemessage1':'PH计健康',
		'dosingsolution':'KH提升液',
		'calsolution':'KH校准液',
		'refillsolution':'补充提升液',
		'setup':'設定',
		'CAsetting':'CRA设定',
		'aiadvisor':'AquaWiz提示: ',
		'entermessage':'给用户的建议',
		'upload':'Set',
        'igotit':'清除',
		'refillcalsolution':'补充校准液',
		
	}
}




export default {
  components: {
    //"line-graph": LineGraph
		},

  data() {
    return {
		u:{	
			serials: "",
			timestamp:"",
			targetKH:"",
			timeHr:"",
			tankKH: "",
			trueKH:"",
			KHdosing: "",
			maxKHdosingPerHr:"",
			PairDev:"",
			KHRemain: "",
			CalRemain:"",
			mlspec:"",
			phSignal: -1,
			KHspec:"",
			er_c: 0, er_pump: 0,
			sleep:"",
			message_dev: "",
			devname:"",
			s_number:"",
			name: "",
			email: "",
			token:"",
			status:"",
			data:"",			
		},
		title: "KH graph",
		nav: Nav,
		poller: null,
		sumStyle: {
			'background-color' : '#0091a5',
			'font-size' : '1.2em',
			'padding' : '0.5em',
			'border-radius' : '0.2em'
		}
    }
  },
	created: function () {
		// `this` points to the vm instance

		//console.log('created: ');
	},

  computed: {
    
  },

  methods: {
	
	fillData: function(sidx) {
	  //let user = this.user;
	  let user = JSON.parse(localStorage.getItem("user")) || this.$store.getters.user || {};    
	  localStorage.removeItem('rftime'); // reset refresh time for kh-graph and CaRx-graph to get data from server
	  //console.log('method: before fillData: localstorage || $store user: ', user,);

	  let serial = '';
	  if (this.u.name === "default" || this.u.name === "khacra") {
		  serial = this.u.serials;  // serials changed by input 
		  user.data.devices=serial; // update localstorage user
		  localStorage.setItem('user', JSON.stringify(user)); // update localstorage with new serials
		  this.sumStyle['background-color'] = '#f4858e'
	  } else if (has(user, 'data.devices')) {
		  serial = user.data.devices;
	  } else {
		  serial = "";
	  }
	  //console.log('method: fillData(): sidx => getData() ', sidx);
	  // this.datacollection = { labels: [], datasets: [] };
	  if (Array.isArray(sidx)) {
		  var sidx_array = sidx
	  } else {
		  var sidx_array = [sidx]
	  }
	  //console.log('method: fillData(): sidx_array => getData() ', sidx_array, serial);
	  getData(this, serial,sidx_array);
	  //setTimeout( () => {  // set timeout 3 sec to wait http request parameters from ui-server
      //      localStorage.setItem('user', JSON.stringify(this.u)); 
	  //		user = JSON.parse(localStorage.getItem("user"));   
      //  }, 3000);
	 
	  //console.log('after fillData: $store user: ', this.$store.getters.user);
      
    },
    setMsg: function (message, timer, sidx) {
        this.u.message_dev[sidx] = message;
        // set time in ms
        setTimeout( () => {
			this.$set(this.u.message_dev, sidx, ""); // clear message after timer second
			 ////// to complete logout and show login page need this 3 items
			//if (this.u.name === "default" && message.match(/device not found/gi)) {   // super user key in wrong serial, do not logout
		    if ((this.u.name === "default" || this.u.name === "khacra") && message.match(/device not found/gi)) {
			} else {   // other user or wrong password, then logout
				this.$store.dispatch("setUser", {name: '', token: ''});
				this.$auth.destroyToken();
				this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
			}
		}, timer*1000);
		
	},
	beforeDestroy() {
		//console.log('method: beforeDestroy()');
		this.stopPoller();
	},
	clearMsg: function (sidx) {
		writeMsg(this,sidx, "");
		this.fillData(sidx);
	},
	addMsg: function (sidx) {
		writeMsg(this, sidx, this.u.message_dev[sidx]);    
	},

	getRandomInt: () => {
		return Math.floor(Math.random() * (50 - 5 + 1)) + 5
		}
	},
	
	mounted() {
	let user = JSON.parse(localStorage.getItem("user")) || this.$store.getters.user || {};  // prevent localstorage not function, get from $store
	//console.log('mounted: this.$store.getters.user: ', this.$store.getters.user);
    //console.log('mounted: localstorage user: ', user);
	///////// Vue parameters = localstored in Login.vue ///////
	this.u.name = user.name;
	this.u.email = user.email;
	this.u.token = user.token; 
	this.u.status = user.status; 
	this.u.data = user.data;
    ///////// handle serials and sidx /////////
	this.u.serials = user.data.devices;
	var sidx = Array.from(Array(this.u.serials.length).keys());  // get all sidx, all serial index
	//console.log('mounted: sidx, serials=', sidx, this.u.serials);
	
	this.u.timestamp  = Array(this.u.serials.length).fill("")
	this.u.targetKH   = Array(this.u.serials.length).fill(0)
	this.u.timeHr     = Array(this.u.serials.length).fill(0)
	this.u.tankKH     = Array(this.u.serials.length).fill(0)
	this.u.trueKH     = Array(this.u.serials.length).fill(0)
	this.u.KHdosing   = Array(this.u.serials.length).fill(0)
	this.u.maxKHdosingPerHr   = Array(this.u.serials.length).fill(0)
	this.u.PairDev   = Array(this.u.serials.length).fill("")
	this.u.KHRemain   = Array(this.u.serials.length).fill(0)
	this.u.CalRemain   = Array(this.u.serials.length).fill(0)
	this.u.mlspec   = Array(this.u.serials.length).fill(0)
	this.u.phSignal   = Array(this.u.serials.length).fill(-1)
	this.u.er_c   = Array(this.u.serials.length).fill(0)
	this.u.er_pump   = Array(this.u.serials.length).fill(0)
	this.u.KHspec   = Array(this.u.serials.length).fill(0)  // KH-settings
	this.u.sleep   = Array(this.u.serials.length).fill(0)   // KH-settings
	this.u.message_dev= Array(this.u.serials.length).fill("")
	this.u.devname= Array(this.u.serials.length).fill("")
	this.u.s_number= Array(this.u.serials.length).fill("")
	
	if (this.$auth.loggedIn()) { 
	  //console.log('mounted: sidx => setTimeout 60min ', sidx);
	  //this.poller = setTimeout(this.fillData(sidx), 5000);
	  //console.log('mounted: this.poller=', this.poller);
	  this.fillData(sidx);
    
	  //console.log("mount: this._data=", this._data);
	  
	  //console.log("My-KH parameters obtained");
	
	} else {
	  this.$auth.destroyToken();
      this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
	} // if this.auth
  },
  
  stopPoller() {
    //console.log('method: clear poller: ', this.poller);
    if (this.poller) {
      clearTimeout(this.poller);
    }
  }
}  // export 
</script>

<style>
.graph {
  max-width: 100%;
  width: 93%;
  min-width: 300px;
  margin: 3% 6% 3% 5%;
}
/*額外做顏色，沒有什麼意義*/
tr.tr-only-hide {color: #D20B2A;}

@media (max-width: 736px) {
  .table-rwd{min-width: 100%;}
  /*針對tr去做隱藏*/
  tr.tr-only-hide {display: none !important;}
  /*讓tr變成區塊主要讓他有個區塊*/
  .table-rwd tr{
    display: block;
    border: 1px solid #ddd;
    margin-top: 5px;
  }
  .table-rwd td {
    text-align: left;
    font-size: 15px;
    overflow: hidden;
    width: 100%;
    display: block;
	}
	.table-rwd td:before {
    /*最重要的就是這串*/
    content: attr(data-th) " : ";
    /*最重要的就是這串*/
    display: inline-block;
    text-transform: uppercase;
    font-weight: bold;
	  margin-right: 10px;
    color: #D20B2A;
  }
  /*當RWD縮小的時候.table-bordered 會有兩條線，所以針對.table-bordered去做修正*/
  .table-rwd.table-bordered td,.table-rwd.table-bordered th,.table-rwd.table-bordered{border:0;}
  
}
</style>



// WEBPACK FOOTER //
// My_KH.vue?0c67a9ac